// Vue core
import Vue from "vue";
import App from "@/App.vue";

// Global styles
import "@/assets/css/custom.css";
import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";

// Plugins and libraries
import vuetify from "@/plugins/vuetify";
import $axios from "@/plugins/axios";
import router from "@/router";
import store from "@/store";

// Custom global helpers
import "@/filters";
import "@/directives";
import "@/plugins/validation";

// Other plugins
import toastPlugin from "@/plugins/toaster";
import { DateTime, Duration } from "luxon";

// ---------------------
// Vue global configs
// ---------------------
Vue.use(toastPlugin, { store });
Vue.prototype.$axios = $axios;
Vue.prototype.$dt = DateTime;
Vue.prototype.$dr = Duration;

Vue.config.productionTip = false;

// ---------------------
// Root Vue Instance
// ---------------------
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
